import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { useLocation, useNavigate } from 'react-router-dom';
import { compose } from 'redux';
import {
  SubNavBarContainer,
  ContentWrapper,
  SubMenuElementContainer,
  Wrapper,
  SubNavBarBackground,
  LogoWrapper,
  StaticLinks,
  TutorLinks,
} from './style';

import { Container } from '../../gridSystem';
import Icon from '../../atoms/Icon';
import { APP_NAVIGATION_TOGGLE, MODAL_OPEN } from '../../../app/redux/actions';
import { CTA, Logo, Text } from '../../atoms';
import routes from '../../../routes';
import { withMediaQueries } from '../../../app/hoc/withMediaQueries';
import ModalNotifications, {
  ModalNotificationsId,
} from '../../atoms/Modals/ModalNotifications';
import { isPublicPath } from '../../../utils/common';

const subMenuElement = ({ type, data }, redirect, isActive = true) => {
  if (type === 'page_link') {
    return (
      <SubMenuElementContainer
        onClick={() => redirect(data?.path)}
        active={isActive}
        key={data?.path}
      >
        <Text type="h3">{data?.text}</Text>
        {!isActive && <Icon type="chevron-right" size={16} />}
      </SubMenuElementContainer>
    );
  }
  return (
    <SubMenuElementContainer
      onClick={() => redirect(data?.uri, type === 'external_link')}
      active={isActive}
      key={data?.uri}
    >
      <Text type="h3">{data?.uri}</Text>
      <Icon type="link-external-01" size={16} />
    </SubMenuElementContainer>
  );
};

const tutorMenuElement = ({
  label,
  isActive,
  onClick,
  order,
  className = '',
}) => {
  return (
    <SubMenuElementContainer
      onClick={onClick}
      active={isActive}
      order={order}
      className={className}
    >
      <Text type="h3">{label}</Text>
      {!isActive && <Icon type="chevron-right" size={16} />}
    </SubMenuElementContainer>
  );
};

const SubNavBar = ({
  mediaIsPhone,
  mediaIsTablet,
  navigationMobile,
  menuLinks,
  menuToggle,
  menuLogo,
  isLogged,
  modalOpen,
  isTutor,
  isCotutor,
  isSupervisor,
  isSubjectExpert,
}) => {
  const navigate = useNavigate();
  const { pathname: currentPath } = useLocation();
  const [activePath, setActivePath] = useState(currentPath);
  const [menuIsOpen, setMenuIsOpen] = useState(navigationMobile);
  const [showCourseLinks, setShowCourseLinks] = useState(false);

  useEffect(() => {
    if (navigationMobile) setMenuIsOpen(true);
    else {
      setTimeout(() => {
        setMenuIsOpen(false);
      }, 250);
    }
  }, [navigationMobile]);

  useEffect(() => {
    setActivePath(currentPath);
    if (navigationMobile) menuToggle();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPath]);

  const changeLocation = (url, external) => {
    if (external) window.open(url, '_blank');
    else navigate(url);
  };

  const isActivePath = (path = '__') => {
    if (path === routes.home.path || path === routes.public.path) {
      return activePath === path;
    }
    return activePath?.includes(path?.normalize());
  };

  const onClickLogo = () => {
    if (isPublicPath(currentPath)) {
      changeLocation(routes.public.path);
    } else {
      changeLocation(routes.home.path);
    }
  };

  return (
    <>
      {navigationMobile && <SubNavBarBackground onClick={menuToggle} />}
      <SubNavBarContainer
        navigationMobile={menuIsOpen}
        className={navigationMobile ? 'slidein' : 'slideout'}
        onClick={(e) => e.stopPropagation()}
      >
        <Container className="content-wrapper">
          <ContentWrapper className="container-fluid">
            {!(mediaIsPhone || mediaIsTablet) && (
              <LogoWrapper>
                <Logo
                  size={Logo.SIZE.MEDIUM}
                  onClick={onClickLogo}
                  src={menuLogo?.src}
                  alt={menuLogo?.alt}
                />
              </LogoWrapper>
            )}
            <Wrapper>
              {menuLinks.map((elem) =>
                subMenuElement(
                  elem,
                  changeLocation,
                  isActivePath(elem?.data?.path)
                )
              )}
            </Wrapper>
            {(mediaIsPhone || mediaIsTablet) && (
              <>
                {isSupervisor ? ( // SUPERVISOR
                  <TutorLinks>
                    <Text type="h3" className="title">
                      ATTIVITÀ SUPERVISOR
                    </Text>
                    <Text type="h3" className="dropdown">
                      Percorsi formativi
                      <CTA
                        type="tertiary"
                        btnText={showCourseLinks ? 'Chiudi' : 'Espandi'}
                        icon={showCourseLinks ? 'minus' : 'plus'}
                        onClick={() => setShowCourseLinks(!showCourseLinks)}
                      />
                    </Text>
                    {showCourseLinks && (
                      <>
                        {tutorMenuElement({
                          label: 'Creazione percorso formativo',
                          isActive:
                            isActivePath(routes.chooseCourseType.path) ||
                            isActivePath(routes.createCourse.path) ||
                            isActivePath(routes.createEvent.path),
                          onClick: () => navigate(routes.chooseCourseType.path),
                          className: 'secondary',
                        })}
                        {tutorMenuElement({
                          label: 'Gestione percorso formativo',
                          isActive:
                            isActivePath(routes.tutorCourseList.path) ||
                            isActivePath(routes.editCourse.path) ||
                            isActivePath(routes.editEvent.path),
                          onClick: () => navigate(routes.tutorCourseList.path),
                          className: 'secondary',
                        })}
                        {tutorMenuElement({
                          label: 'Gestione eventi dal vivo',
                          isActive: isActivePath(routes.liveEventList.path),
                          onClick: () => navigate(routes.liveEventList.path),
                          className: 'secondary',
                        })}
                        {tutorMenuElement({
                          label: 'Gestione richieste di approvazione',
                          isActive: isActivePath(routes.approvalList.path),
                          onClick: () => navigate(routes.approvalList.path),
                          className: 'secondary',
                        })}
                      </>
                    )}
                    {tutorMenuElement({
                      label: 'I miei gruppi',
                      isActive: isActivePath(routes.groupList.path),
                      onClick: () => navigate(routes.groupList.path),
                      order: 2,
                    })}
                    {tutorMenuElement({
                      label: 'Statistiche e reportistica',
                      isActive: isActivePath(routes.statistics.path),
                      onClick: () => navigate(routes.statistics.path),
                      order: 3,
                    })}
                    {tutorMenuElement({
                      label: 'Elenco Log',
                      isActive: isActivePath(routes.logsList.path),
                      onClick: () => navigate(routes.logsList.path),
                      order: 4,
                    })}
                    {tutorMenuElement({
                      label: 'Creazione newsletter',
                      isActive: isActivePath(routes.sendNewsletter.path),
                      onClick: () => navigate(routes.sendNewsletter.path),
                      order: 5,
                    })}
                    {tutorMenuElement({
                      label: 'Catalogo attività',
                      isActive: isActivePath(routes.scormList.path),
                      onClick: () => navigate(routes.scormList.path),
                      order: 6,
                    })}
                    {(isSupervisor || isSubjectExpert) &&
                      tutorMenuElement({
                        label: 'Scambio documentale',
                        isActive: isActivePath(routes.documentsExpert.path),
                        onClick: () => navigate(routes.documentsExpert.path),
                        order: 7,
                      })}
                  </TutorLinks>
                ) : isTutor || isCotutor ? (
                  <TutorLinks>
                    <Text type="h3" className="title">
                      ATTIVITÀ TUTOR
                    </Text>
                    {isTutor && ( // TUTOR ONLY
                      <>
                        {tutorMenuElement({
                          label: 'Creazione percorso formativo',
                          isActive:
                            isActivePath(routes.chooseCourseType.path) ||
                            isActivePath(routes.createCourse.path) ||
                            isActivePath(routes.createEvent.path),
                          onClick: () => navigate(routes.chooseCourseType.path),
                          order: 1,
                        })}
                        {tutorMenuElement({
                          label: 'I miei gruppi',
                          isActive: isActivePath(routes.groupList.path),
                          onClick: () => navigate(routes.groupList.path),
                          order: 3,
                        })}
                        {tutorMenuElement({
                          label: 'Statistiche e reportistica',
                          isActive: isActivePath(routes.statistics.path),
                          onClick: () => navigate(routes.statistics.path),
                          order: 4,
                        })}
                      </>
                    )}
                    {tutorMenuElement({
                      // ALSO COTUTOR
                      label: 'Gestione percorso formativo',
                      isActive:
                        isActivePath(routes.tutorCourseList.path) ||
                        isActivePath(routes.editCourse.path) ||
                        isActivePath(routes.editEvent.path),
                      onClick: () => navigate(routes.tutorCourseList.path),
                      order: 2,
                    })}
                    {tutorMenuElement({
                      label: 'Catalogo attività',
                      isActive: isActivePath(routes.scormList.path),
                      onClick: () => navigate(routes.scormList.path),
                      order: 5,
                    })}
                    {(isSupervisor || isSubjectExpert) &&
                      tutorMenuElement({
                        label: 'Scambio documentale',
                        isActive: isActivePath(routes.documentsExpert.path),
                        onClick: () => navigate(routes.documentsExpert.path),
                        order: 6,
                      })}
                  </TutorLinks>
                ) : isSupervisor || isSubjectExpert ? (
                  <TutorLinks>
                    <Text type="h3" className="title">
                      ATTIVITÀ ESPERTO
                    </Text>
                    {tutorMenuElement({
                      label: 'Scambio documentale',
                      isActive: isActivePath(routes.documentsExpert.path),
                      onClick: () => navigate(routes.documentsExpert.path),
                      order: 6,
                    })}
                  </TutorLinks>
                ) : null}
                {isLogged && (
                  <StaticLinks>
                    <div
                      className={
                        currentPath === routes.bookmarks.path
                          ? 'link active'
                          : 'link'
                      }
                      onClick={() => navigate(routes.bookmarks.path)}
                    >
                      <Text type="h3">Preferiti</Text>
                      <Icon type="star-01" />
                    </div>
                    <div
                      className={
                        currentPath === routes.notifications.path
                          ? 'link active'
                          : 'link'
                      }
                      onClick={() => modalOpen(ModalNotificationsId)}
                    >
                      <Text type="h3">Notifiche</Text>
                      <Icon type="bell-01" />
                    </div>
                  </StaticLinks>
                )}
              </>
            )}
          </ContentWrapper>
        </Container>
      </SubNavBarContainer>
      {(mediaIsPhone || mediaIsTablet) && <ModalNotifications />}
    </>
  );
};

SubNavBar.propTypes = {
  // HOC withMediaQueries
  mediaIsPhone: PropTypes.bool.isRequired,
  mediaIsTablet: PropTypes.bool.isRequired,
  // HOC (connect, state)
  navigationMobile: PropTypes.bool.isRequired,
  menuLinks: PropTypes.array,
  menuLogo: PropTypes.object,
  isLogged: PropTypes.bool,
  isTutor: PropTypes.bool,
  isCotutor: PropTypes.bool,
  isSupervisor: PropTypes.bool,
  isSubjectExpert: PropTypes.bool,
  // HOC dispatch
  menuToggle: PropTypes.func,
  modalOpen: PropTypes.func,
};

export default compose(
  connect(
    (state) => {
      const {
        navigationMobile,
        authState: { isLogged },
      } = state.app;
      const { isTutor, isCotutor, isSupervisor, isSubjectExpert } = state.user;
      return {
        navigationMobile,
        isLogged,
        isTutor,
        isCotutor,
        isSupervisor,
        isSubjectExpert,
      };
    },
    (dispatch) => ({
      menuToggle: () => dispatch({ type: APP_NAVIGATION_TOGGLE }),
      modalOpen: (id) => dispatch({ type: MODAL_OPEN, id }),
    })
  ),
  withMediaQueries
)(SubNavBar);
